import 'slick-carousel';

let _this =  {

	/*-------------------------------------------------------------------------------
		# Cache dom and strings
	-------------------------------------------------------------------------------*/
	$dom: {
		imageSlider: $('.ig-block-image-slider__slider')
    },

    vars: {
	},

	/*-------------------------------------------------------------------------------
		# Initialize
	-------------------------------------------------------------------------------*/
	init: function () {

        this.$dom.imageSlider.slick({
			slidesToScroll: 1,
			slidesToShow: 1,
			infinite: true,
			autoplay: false,
			speed: 1500,
			pauseOnHover: false,
			arrows: true,
			responsive: [
				{
					breakpoint: 992,
					settings: {
						adaptiveHeight: true
					}
				},
			],
			prevArrow: `<div class='arrow-container arrow-container--left'>
							<svg width="24" height="24" xmlns="http://www.w3.org/2000/svg" fill-rule="evenodd" clip-rule="evenodd"><path d="M21.883 12l-7.527 6.235.644.765 9-7.521-9-7.479-.645.764 7.529 6.236h-21.884v1h21.883z"/></svg>
						</div>`,
			nextArrow : `<div class='arrow-container arrow-container--right'>
							<svg width="24" height="24" xmlns="http://www.w3.org/2000/svg" fill-rule="evenodd" clip-rule="evenodd"><path d="M21.883 12l-7.527 6.235.644.765 9-7.521-9-7.479-.645.764 7.529 6.236h-21.884v1h21.883z"/></svg>
						</div>`
		});

    },

};

export default _this;